import { FieldErrors, FieldValues, UseFormRegister } from "react-hook-form";
import { Rules } from "../../types/integrations";
import { Input } from "../ui/input";
import { Field, FieldLabel, FieldError } from "../ui/field";

interface IProps {
  label: string;
  placeholder: string;
  name: string;
  register: UseFormRegister<FieldValues>;
  rules: Rules;
  errors: FieldErrors<FieldValues>;
  disabled?: boolean;
  value?: string;
  hidden?: boolean;
}

export const FormInput = ({
  label,
  placeholder,
  name,
  register,
  rules,
  errors,
  disabled,
  value,
  hidden
}: IProps) => {
  if (hidden) return null;
  
  return (
    <Field>
      <FieldLabel htmlFor={name}>
        {label}
      </FieldLabel>
      <Input
        id={name}
        defaultValue={value}
        placeholder={placeholder}
        {...register(name, rules)}
        disabled={disabled}
        aria-invalid={!!errors[name]}
      />
      {errors[name] && (
        <FieldError>{`${errors[name]?.message}`}</FieldError>
      )}
    </Field>
  );
};
